<template>
	<div>
		<section
			ref="claim_timeline"
			class="timeline"
		>
			<div>
				<div class="claim-description-and-link">
					<a :href="`/bo/claims/view?id=${claimId}`">
						<translate>Corresponding Claim</translate>
					</a>
				</div>
				<div
					ref="claim_form_visit_tulip_container"
					class="claim-form-visit-tulip-container"
				>
					<a :href="`/bo/claims/view?id=${claimId}`">
						<div id="claim-form-visit-tulip">
							<img
								id="claim-form-visit-tulip-image"
								:src="tulipImg"
								alt=""
								@mouseenter=" () => { tulipImg = '/frontoffice/images/brand/icons/icon-228-inverted.png'; }"
								@mouseleave=" () => { tulipImg = '/frontoffice/images/brand/icons/icon-228.png'; }"
							>
						</div>
					</a>
				</div>
			</div>
			<ul>
				<li
					v-for="(claimFormVisit, index) in claimFormVisits"
					:key="index"
					class="tulips_stem_part"
					:class="{ 'in-view': infoInView[index] }"
				>
					<div>
						<div class="vertical-timeline-item-description">
							<span> {{ formatDate(claimFormVisit.visit_start_time) }} </span>
						</div>
						<div
							class="vertical-timeline-item-contents"
							:style="{ width: infoWidth }"
						>
							<ul>
								<li
									v-for="(claimFormDataChange, changeDescription) in claimFormDataChanges[claimFormVisit.id]"
									:key="claimFormDataChange.id"
								>
									<div>
										<label>{{ changeDescription }}</label>
										<ul>
											<li
												v-for="(change, innerIndex) in claimFormDataChange"
												:key="innerIndex"
											>
												{{ change }}
											</li>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div
						v-if="index % 2 === 0"
						class="tulips-leaf-div"
						:class="{ 'in-view': infoInView[index] }"
						@click="manageStemExtension(index)"
						@mouseenter="setLeafImgHighlighted(index)"
						@mouseleave="setLeafImgIdle(index)"
					>
						<img
							:key="leafsStates[index]"
							class="svg tulips-leaf tulips-leaf-right idle-tulips-leaf"
							:class="{ 'in-view': infoInView[index] }"
							:src="leafsStates[index]"
							alt=""
						>
					</div>
					<div
						v-else
						class="tulips-leaf-div"
						:class="{ 'in-view': infoInView[index] }"
						@click="manageStemExtension(index)"
						@mouseenter="setLeafImgHighlighted(index)"
						@mouseleave="setLeafImgIdle(index)"
					>
						<img
							:key="leafsStates[index]"
							class="svg tulips-leaf tulips-leaf-left idle-tulips-leaf"
							:class="{ 'in-view': infoInView[index] }"
							:src="leafsStates[index]"
							alt=""
						>
					</div>
				</li>
			</ul>
		</section>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'VerticalTulipTimeline',
	props: {
		claimId: {
			type: Number,
			required: true,
		},
	},
	data () {
		return {
			claimFormVisits: [],
			claimFormDataChanges: [],

			items: [],
			itemLeafs: [],
			itemLeafDivs: [],

			timelineSingleClaimFormVisitChanges: [],
			tulipContainer: [],
			timelineStemParts: [],

			leafsStates: [],
			tulipImg: '/frontoffice/images/brand/icons/icon-228.png',

			infoInView: [],
			infoWidth: '100px',
		};
	},
	mounted () {
		// Retrieve the claim visits related to the said claim
		axios
			.get(`/bo/claims/claimVisits?claim_id=${this.claimId}`)
			.then((response) => {

				this.claimFormVisits = response.data;

				this.initializeElementInfoArrays();

				// Get all of the elements which need to be checked while scrolling
				this.items = this.$el.getElementsByClassName('tulips_stem_part');
				this.itemLeafs = this.$el.querySelectorAll('.tulips-leaf');
				this.itemLeafDivs = this.$el.querySelectorAll('.tulips-leaf-div');

				this.$nextTick(function () {
					const timelineWidth = this.$refs.claim_timeline.clientWidth;

					this.infoWidth = Math.round(0.9 * timelineWidth) + 'px';

					this.checkVisibilityOfElements();
				});
			})
			.catch((error) => {
				window.captureException(error);
			});

		// Retrieve the claim form data changes related to the claim in question
		axios
			.get(`/bo/claims/claimVisitDataChanges?claim_id=${this.claimId}`)
			.then((response) => {

				this.claimFormDataChanges = response.data;

				// Get elements which are to be modified when a claim form is data is viewed
				this.timelineSingleClaimFormVisitChanges = this.$el.getElementsByClassName('vertical-timeline-item-contents');
				this.tulipContainer = this.$refs.claim_form_visit_tulip_container;
				this.timelineStemParts = this.$el.getElementsByClassName('tulips_stem_part');

				this.$nextTick(function () {
					this.checkVisibilityOfElements();
				});
			})
			.catch((error) => {
				window.captureException(error);
			});
	},
	created () {
		// Add the necessary listeners on resize and scroll
		window.addEventListener('scroll', this.checkVisibilityOfElements);
		window.addEventListener('resize', this.handleResize);
	},
	unmounted () {
		// Remove the set listeners
		window.removeEventListener('scroll', this.checkVisibilityOfElements);
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		/**
		 * Initializes the arrays containing info on elements to the beginning states. E.g. which picture is used
		 * for the leafs.
		 *
		 * @returns {void}
		 * @protected
		 */
		initializeElementInfoArrays: function () {
			// Get the div where the tulip resides
			this.claimFormVisits.forEach(() => {
				this.leafsStates.push('/bo/images/tulipsleaf.svg');
				this.infoInView.push(false);
			});
		},

		/**
		 * Sets the src of the element at index `index` to be the green leaf image.
		 *
		 * @param {number} index corresponds to the element in question
		 * @returns {void}
		 * @protected
		 */
		setLeafImgIdle: function (index) {
			this.$set(this.leafsStates, index, '/bo/images/tulipsleaf.svg');
		},

		/**
		 * Sets the src of the element at index `index` to be the orange leaf image.
		 *
		 * @param {number} index corresponds to the element in question
		 * @returns {void}
		 * @protected
		 */
		setLeafImgHighlighted: function (index) {
			this.$set(this.leafsStates, index, '/bo/images/tulipsleafHighlighted.svg');
		},

		/**
		 * Determines whether the element is visible on = the screen
		 *
		 * @param {*} element the element we want to check if is bounded
		 * @returns {boolean} whether the element is in the viewport
		 * @protected
		 */
		isElementInViewport: function (element) {
			const rect = element.getBoundingClientRect();

			return (rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		},

		/**
		 * Helper function which is invoked on scrolling in order to check whether the elements are on screen.
		 *
		 * @returns {void}
		 * @protected
		 */
		checkVisibilityOfElements: function () {
			for (let i = 0; i < this.items.length; i++) {
				if (this.isElementInViewport(this.items[i])) {
					this.$set(this.infoInView, i, true);
				}
			}
		},

		/**
		 * Handles the 'opening' of the stem upon clicking the leaf
		 *
		 * @param {number} i the index of the stems to manage
		 * @returns {void}
		 * @protected
		 */
		manageStemExtension: function (i) {
			const currentStyle = window.getComputedStyle(this.timelineSingleClaimFormVisitChanges[i]);

			// Currently the info is shown, it needs to be hidden
			if (currentStyle.visibility !== 'hidden') {
				this.timelineSingleClaimFormVisitChanges[i].style.visibility = 'hidden';
				this.timelineSingleClaimFormVisitChanges[i].style.opacity = 0;
				this.timelineStemParts[i].style.marginBottom = '0';

				// Info section disappears before the stems have moved
				this.timelineSingleClaimFormVisitChanges[i].style.transitionDelay = '0s';

				// Stems move after the info is hidden
				for (const item of this.timelineStemParts) {
					item.style.transitionDelay = '0.2s';
				}

				// Checks whether the leafs are visible after the info section has been closed
				setTimeout(this.checkVisibilityOfElements, 700);

				// Currently the info is hidden, it needs to be shown
			} else {
				// Stems move before the info is shown
				for (const item of this.timelineStemParts) {
					item.style.transitionDelay = '0s';
				}
				// Info sections appear after the stems have moved
				this.timelineSingleClaimFormVisitChanges[i].style.transitionDelay = '0.2s';

				this.timelineSingleClaimFormVisitChanges[i].style.visibility = 'visible';
				this.timelineSingleClaimFormVisitChanges[i].style.opacity = 1;
				this.timelineStemParts[i].style.marginBottom = '' + this.timelineSingleClaimFormVisitChanges[i].offsetHeight + 'px';
			}
		},

		/**
		 * Adjusts the width of all of the claim form visit info elements after the resizing of the screen.
		 *
		 * @returns {void}
		 * @protected
		 */
		handleResize: function () {
			for (const item of this.timelineSingleClaimFormVisitChanges) {
				// Save for later  and then remove the transition delay so that the change is instant
				const transitionDelayBefore = item.style.transitionDelay;
				const transitionBefore = item.style.transition;

				item.style.transitionDelay = '0s';
				item.style.transition = 'none';

				// Recalculate the width of the info section based on the width of the entire timeline
				const timelineWidth = this.$refs.claim_timeline.clientWidth;

				this.infoWidth = Math.round(0.9 * timelineWidth) + 'px';

				// Re-add the saved transition delay so that the info elements open and close gradually
				item.style.transitionDelay = transitionDelayBefore;
				item.style.transition = transitionBefore;
			}
		},

		/**
		 * Formats the given UTC date to the project-wide standard 'DD-MM-YYYY hh:ii:ss'.
		 *
		 * @param {string} UTCDate the date to be formatted represented in a UTC format using a string.
		 * @returns {string} Formatted date
		 * @protected
		 */
		formatDate: function (UTCDate) {
			const date = new Date(UTCDate);

			const year = date.getFullYear();
			let month = date.getMonth() + 1;
			let day = date.getDate();

			let hours = date.getHours();
			let minutes = date.getMinutes();
			let seconds = date.getSeconds();

			if (day < 10) {
				day = '0' + day;
			}
			if (month < 10) {
				month = '0' + month;
			}

			if (hours < 10) {
				hours = '0' + hours;
			}

			if (minutes < 10) {
				minutes = '0' + minutes;
			}

			if (seconds < 10) {
				seconds = '0' + seconds;
			}

			return day + '-' + month + '-' + year + ' ' + hours + ':' + minutes + ':' + seconds;
		},
	},
};
</script>

<style scoped>

/* Container for the tulip assist logo on top of the tulip */
.timeline .claim-form-visit-tulip-container {
       background: transparent;
       border-width: 0;
       height: 100px;
       margin-left: auto;
       margin-right: auto;
       margin-top: 5%;
       width: 100px;
   }

/* Tulip assist logo specialized container which handles the reference on top of the tulip */
.timeline #claim-form-visit-tulip {
       height: 100px;
       width: 100px;
   }

/* Tulip assist logo on top of the tulip */
.timeline #claim-form-visit-tulip-image {
       height: 100px;
       width: 100px;
   }

/* Text to the left of the tulip flower - Represents a link to the claim */
.timeline .claim-description-and-link {
    position: absolute;
}

.timeline .claim-description-and-link a {
    margin-left: auto;
    margin-right: auto;
}

/* Stem - relates to one claim */
.timeline > ul {
    padding-left: 0;
    margin-top: 0;
    margin-bottom: 5%;
}

/* Part of the stem - relates to one claim form visit */
.timeline > ul > li {
    list-style-type: none;
    position: relative;
    height: 180px;
    width: 7px;
    margin: 0 auto;
    padding-top: 75px;
    background: #68bd45;
    transition: all .5s ease-in-out;
}

/* Tulip's leaf in general - relates to one claim form visit */
.timeline .tulips-leaf {
    opacity: 0;
    cursor: pointer;
}

/* Tulip's leaf in general (when in view) - relates to one claim form visit */
.timeline .tulips-leaf.in-view {
    transition: 1s ease-in;
    opacity: 1;
}

/* Tulip's right leaf - relates to one claim form visit */
.timeline .tulips-leaf-right {
    position: absolute;
    transform: translateX(3px);
    -ms-transform: translateX(3px);
    bottom: 0;
    width: 100px;
    height: 130px;
}

/* Tulip's left leaf - relates to one claim form visit */
.timeline .tulips-leaf-left {
    position: absolute;
    bottom: 0;
    transform: translateX(-96%) scaleX(-1);
    -ms-transform: translateX(-96%) scaleX(-1);
    width: 100px;
    height: 130px;
}

/* Text next to a tulip's leaf - relates to one claim form visit */
.timeline > ul > li > div div.vertical-timeline-item-description {
    position: relative;
    width: 300px;
    padding: 15px;
    background:transparent;
    bottom: 0;
    visibility: hidden;
    opacity: 0;
    transition: all .5s ease-in-out;
}

/* Text next to a tulip's right leaf - relates to one claim form visit */
.timeline > ul > li:nth-child(odd) div.vertical-timeline-item-description {
    left: 100px;
    transform: translate3d(200px,0,0);
    -ms-transform: translate3d(200px,0,0);
}

/* Text next to a tulip's left leaf - relates to one claim form visit */
.timeline > ul > li:nth-child(even) div.vertical-timeline-item-description {
    left: -400px;
    text-align: right;
    transform: translate3d(-200px,0,0);
    -ms-transform: translate3d(-200px,0,0);
}

/* Text next to a tulip's leaf (when in view) - relates to one claim form visit */
.timeline > ul > li.in-view div.vertical-timeline-item-description {
    transform: none;
    visibility: visible;
    opacity: 1;
}

.timeline > ul > li > div > div.vertical-timeline-item-contents {
    margin: 0;
    transform: translateX(-50%) translateY(54px);
    -ms-transform: translateX(-50%) translateY(54px);
    visibility: hidden;
    opacity: 0;
    transition: all 0.15s ease-in-out;
    border: 2px solid #68bd45;
    border-radius: 10px;
    padding: 20px;
}

.timeline > ul > li > div > div.vertical-timeline-item-contents > div > ul {
    margin-bottom: 10px
}
</style>
